var React = require('react');

function ChatStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm283-310 117-71 117 71-31-133 104-90-137-11-53-126-53 126-137 11 104 90-31 133Z"}));
}

ChatStar.defaultProps = {"height":"1em","viewBox":"0 -960 960 960","width":"1em","fill":"currentColor","className":"h-4 w-4"};

module.exports = ChatStar;

ChatStar.default = ChatStar;
